import { graphql, useStaticQuery } from "gatsby";

// PRODUCTS
export const fetchAllProducts = () => {
  const data = useStaticQuery(graphql`
    {
      allWpSimpleProduct {
        totalCount
        nodes {
          allPaActiveIngredient {
            nodes {
              name
              slug
              id
            }
          }
          related {
            relatedProducts: nodes {
              name
              sku
              slug
              databaseId
              description
              image {
                sourceUrl
                altText
              }
              ... on WpSimpleProduct {
                id
                name
                price
                regularPrice
                onSale
                stockStatus
              }
            }
          }
          isOnPromotion {
            isonpromotion
            additionalTag
          }
          topSaleProducts {
            topsaleproduct
          }
          name
          sku
          id
          slug
          description
          databaseId
          stockStatus
          salePrice
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
              altText
            }
          }
          productTags {
            nodes {
              name
              id
              slug
            }
          }
          productCategories {
            cat: nodes {
              name
              id
              slug
            }
          }
          ... on WpSimpleProduct {
            id
            name
            price
            regularPrice
            onSale
            salePrice
            stockStatus
            tierPrice {
              tierPrice {
                price
                price2
                price3
                price4
              }
            }
          }
        }
      }
      allWpVariableProduct {
        totalCount
        nodes {
          allPaActiveIngredient {
            nodes {
              name
              slug
              id
            }
          }
          related {
            relatedProducts: nodes {
              name
              sku
              slug
              databaseId
              description
              image {
                sourceUrl
                altText
              }
              ... on WpVariableProduct {
                id
                name
                price
                regularPrice
                onSale
                stockStatus
                variations {
                  nodes {
                    id
                    name
                    databaseId
                    price
                    regularPrice
                    onSale
                    salePrice
                    stockQuantity
                  }
                }
              }
            }
          }
          isOnPromotion {
            isonpromotion
            additionalTag
          }
          topSaleProducts {
            topsaleproduct
          }
          name
          sku
          id
          slug
          description
          databaseId
          stockStatus
          salePrice
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
              altText
            }
          }
          productTags {
            nodes {
              name
              id
              slug
            }
          }
          productCategories {
            cat: nodes {
              name
              id
              slug
            }
          }
          ... on WpVariableProduct {
            id
            name
            price
            regularPrice
            onSale
            salePrice
            stockStatus
            tierPrice {
              tierPrice {
                price
                price2
                price3
                price4
              }
            }
          }
        }
      }
    }
  `);

  const simpleProducts = data.allWpSimpleProduct.nodes.map((product: any) => ({
    ...product,
    isVariable: false,
  }));

  const variableProducts = data.allWpVariableProduct.nodes.map((product: any) => ({
    ...product,
    isVariable: product.price.includes("-"),
  }));

  return [...simpleProducts, ...variableProducts];
};
